import { AlertTriangleIcon } from 'lucide-react'
import { toast } from 'sonner'

import { ampli } from '@/shared/lib/ampli'
import Sentry from '@/shared/lib/sentry'
import { download } from '@/shared/tools/report'

import buildPromoImportTemplateBlob from './buildImportTemplateBlob'

export function buildDownloadPromoCampaignTemplateHandler() {
	return async () => {
		ampli.promoDownloadTemplate()
		try {
			const rows = [
				{
					sku: 's1',
					title: 't1',
					discount_price: 10,
					discount_percent: 2,
					discount_sum: null,
					predicted_growth_rate: 1,
				},
			]
			const blob = await buildPromoImportTemplateBlob(rows)
			download(blob, 'promo_import_template.xlsx')
		} catch (error) {
			Sentry.captureException(error)
			toast('Failed to download template', {
				icon: <AlertTriangleIcon className='text-warning' />,
				duration: 5000,
			})
		}
	}
}
